import type { Order } from '../types';
import { menuItems } from './menu';

// Helper to get a menu item by ID, ensuring it's not undefined
const getItem = (id: number) => {
  const item = menuItems.find(m => m.id === id);
  if (!item) throw new Error(`Menu item with id ${id} not found`);
  return item;
};

const calculateTotals = (items: { price: number; quantity: number }[]) => {
    const totalAmount = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    // In NZ, with 15% GST, the GST portion of a final price is Total * (15 / 115)
    const taxAmount = totalAmount * (15 / 115);
    const subtotal = totalAmount - taxAmount;
    return { subtotal, taxAmount, totalAmount };
};

export const initialOrders: Order[] = [
  {
    id: 'ORD-1',
    orderType: 'dine-in',
    tableNumber: 12,
    tableId: 12,
    customerId: 1,
    items: [
      { ...getItem(201), quantity: 1, status: 'pending' },
      { ...getItem(204), quantity: 1, status: 'pending' },
      { ...getItem(403), quantity: 2, status: 'pending' },
    ],
    status: 'new',
    timestamp: Date.now() - 120000, // 2 minutes ago
    paymentStatus: 'unpaid',
    payments: [],
    ...calculateTotals([
      { ...getItem(201), quantity: 1 },
      { ...getItem(204), quantity: 1 },
      { ...getItem(403), quantity: 2 },
    ]),
  },
  {
    id: 'ORD-2',
    orderType: 'dine-in',
    tableNumber: 5,
    tableId: 5,
    items: [
      { ...getItem(102), quantity: 1, status: 'pending' },
      { ...getItem(205), quantity: 2, status: 'pending' },
      { ...getItem(401), quantity: 2, status: 'pending' },
    ],
    status: 'new',
    timestamp: Date.now() - 300000, // 5 minutes ago
    paymentStatus: 'unpaid',
    payments: [],
    ...calculateTotals([
      { ...getItem(102), quantity: 1 },
      { ...getItem(205), quantity: 2 },
      { ...getItem(401), quantity: 2 },
    ]),
  },
  {
    id: 'ORD-3',
    orderType: 'dine-in',
    tableNumber: 8,
    tableId: 8,
    items: [
      { ...getItem(202), quantity: 1, status: 'completed' },
      { ...getItem(502), quantity: 1, status: 'pending' },
    ],
    status: 'preparing',
    timestamp: Date.now() - 600000, // 10 minutes ago
    paymentStatus: 'unpaid',
    payments: [],
    ...calculateTotals([
      { ...getItem(202), quantity: 1 },
      { ...getItem(502), quantity: 1 },
    ]),
  },
    {
    id: 'ORD-4',
    orderType: 'dine-in',
    tableNumber: 3,
    tableId: 3,
    items: [
      { ...getItem(301), quantity: 2, status: 'completed' },
      { ...getItem(404), quantity: 2, status: 'completed' },
    ],
    status: 'ready',
    timestamp: Date.now() - 900000, // 15 minutes ago
    paymentStatus: 'unpaid',
    payments: [],
    ...calculateTotals([
      { ...getItem(301), quantity: 2 },
      { ...getItem(404), quantity: 2 },
    ]),
  },
];